module.exports = __webpack_public_path__ + "img/ac-mobile-hover.aefc9e2d.png";